import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import {LinearProgress} from '@mui/material';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const businessTypeList = [
  'Wholesaler',
  'Manufacturer',
  'Exporter',
  'Importer',
  'Retailer'
];

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  const userObj = useSelector(state => state.userDetails);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [pageLoading, setPageLoading] = React.useState(false);


  
  const [cities, setCities] = React.useState([]);
  const [countries, setCountries] = React.useState([]);
  const [businessTypes, setBusinessTypes] = React.useState([]);  

  const [companyName, setCompanyName] = React.useState("");
  const [contactPerson, setContactPerson] = React.useState("");
  const [businessTitle, setBusinessTitle] = React.useState("Owner");
  const [address, setAddress] = React.useState("");
  const [city, setCity] = React.useState("");
  const [state, setState] = React.useState("");
  const [country, setCountry] = React.useState("INDIA");
  const [pincode, setPincode] = React.useState("");
  const [mobile, setMobile] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [website, setWebsite] = React.useState("");

  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}


  React.useEffect(() => {	
    if(open){
      getApiCities();
      getApiCountry();
    }
    if(open && props.dataObj && props.dataObj.autoId){
      setCompanyName(props.dataObj.companyName);
      setContactPerson(props.dataObj.contactPerson);
      setBusinessTitle(props.dataObj.businessTitle);
      setAddress(props.dataObj.address);
      setCity(props.dataObj.city);
      setState(props.dataObj.state);
      setCountry(props.dataObj.country);
      setPincode(props.dataObj.pincode);
      setEmail(props.dataObj.email);
      setMobile(props.dataObj.mobile);
      setPhone(props.dataObj.phone);
      setWebsite(props.dataObj.website);

    }else{
      setCompanyName("");
      setContactPerson("");
      setBusinessTitle("Owner");
      setAddress("");
      setCity("");
      setState("");
      setCountry("INDIA");
      setPincode("");
      setEmail("");
      setMobile("");
      setPhone("");
      setWebsite("");

    }
	}, [props.dataObj,open]);

  async function getApiCities(){ 
    let apiUrl=API_URL+'/admin-list-city?sorting=city';
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'uid': userObj.loginId,
        'fullName': userObj.fullName,
        'token': userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    setPageLoading(true);
    await axios(config)
       .then(response => {
      setPageLoading(false);
      //document.write(JSON.stringify(response.data));
      if(response && response.data && response.data.responseTxt==="success"){  
        setCities(response.data.obj);
      }
    })
  }

  async function getApiCountry(){ 
    let apiUrl=API_URL+'/admin-list-country';
    let axiosHeader = {
        'Content-Type': 'multipart/mixed',
        'device': 'web',
        'uid': userObj.loginId,
        'fullName': userObj.fullName,
        'token': userObj.token,
    };
    const config = {
      method: 'get',
      url: apiUrl,
      headers: axiosHeader
    }
    setPageLoading(true);
    await axios(config)
       .then(response => {
      setPageLoading(false);
      if(response && response.data && response.data.responseTxt==="success"){  
        setCountries(response.data.obj);
      }
    })
  }

	function saveData(){
    if(!companyName){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter company name");			
      return false;
    }
    if(!city){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter city");			
      return false;
    }
    if(!country){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter country");			
      return false;
    }
    
		if(companyName && companyName.length>1){ 
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'uid': props.userObj.loginId,
					'fullName': props.userObj.fullName,
					'token': props.userObj.token,
				}
			}; 
			const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('id', props.dataObj.autoId);
      } 
      data.append('companyName', companyName);
      data.append('contactPerson', contactPerson);
      data.append('businessTitle', businessTitle);
      data.append('address', address);
      data.append('city', city);
      data.append('state', state);
      data.append('country', country);
      data.append('pincode', pincode); 
      data.append('mobile', mobile);
      data.append('email', email);
      data.append('phone', phone);
      data.append('website', website);
      
      let apiURL='/create-company-free';
      let myMessage="Company has been created.";
      if(props.dataObj!=null && props.dataObj.autoId){
          apiURL='/update-company-free';
          myMessage="Company has been updated.";
      }
             
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){          
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage(myMessage);
          window.location.reload();	
					return false;
        }else if(response.data.responseTxt==="company_name_already_exists"){
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage("This company name was created earlier. Kindly enter another company name.");
            return false;  					

        }else if(response.data.responseTxt==="email_already_exists"){
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage("This email was created earlier. Kindly enter another email.");
            return false;  					

        }else if(response.data.responseTxt==="mobile_already_exists"){
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage("This mobile was created earlier. Kindly enter another mobile.");
            return false;  					

        }else if(response.data.responseTxt==="website_already_exists"){
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage("This website was created earlier. Kindly enter another website.");
            return false;  					

        }else if(response.data.responseTxt==="invalidtoken"){
            window.location.href='invalidtoken';
  
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("It could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}

  // function nameOnly(event) {
  //   if (!/[a-z ]/i.test(event.key)) {
  //     event.preventDefault();
  //     return false;
  //   }
  // }

  function numberOnly(event) {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }
  
  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
          {pageLoading?<LinearProgress />:null}
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{(props.dataObj && props.dataObj.autoId>0)?<>Edit</>:<>New</>}</h3></div>
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{paddingTop:10}} >
                              <TextField label='Company Name' onChange={event => setCompanyName(event.target.value)} value={companyName} placeholder={'Enter company name'} fullWidth size='small' variant="outlined" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{paddingTop:10}} >
                              <TextField label='Contact Person' onChange={event => setContactPerson(event.target.value)} value={contactPerson} placeholder={'Enter contact person'} fullWidth size='small' variant="outlined" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{paddingTop:10}} >
                              <TextField label='Business Title' onChange={event => setBusinessTitle(event.target.value)} value={businessTitle} placeholder={'Enter business title'} fullWidth size='small' variant="outlined" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{paddingTop:10}} >
                              <TextField label='Address' onChange={event => setAddress(event.target.value)} value={address} placeholder={'Enter address'} fullWidth size='small' variant="outlined" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{paddingTop:10}} >
                              <FormControl fullWidth size="small">
                                <InputLabel id="city-select-small-label">City</InputLabel>
                                <Select
                                  labelId="city-select-small-label"
                                  id="city-select-small"
                                  value={city}
                                  label="City"
                                  onChange={event => setCity(event.target.value)}
                                  
                                >
                                  <MenuItem value="">
                                    <em>None</em>
                                  </MenuItem>
                                  {(cities || []).map((row,i)=>(
                                    <MenuItem key={'mi'+i} value={row.city} >{row.city}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{paddingTop:10}} >
                              <TextField label='State' onChange={event => setState(event.target.value)} value={state} placeholder={'Enter state'} fullWidth size='small' variant="outlined" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{paddingTop:10}} >
                              <FormControl fullWidth size="small">
                                <InputLabel id="country-select-small-label">Country</InputLabel>
                                <Select
                                  labelId="country-select-small-label"
                                  id="country-select-small"
                                  value={country}
                                  label="Country"
                                  onChange={event => setCountry(event.target.value)}
                                >
                                  {(countries || []).map((row,i)=>(
                                    <MenuItem key={'mic'+i} value={row} >{row}</MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{paddingTop:10}} >
                              <TextField label='Pin Code' onChange={event => setPincode(event.target.value)} value={pincode} placeholder={'Enter pincode'} fullWidth size='small' variant="outlined" onKeyPress={(event) => {numberOnly(event);}} inputProps={{ maxLength: 6 }} />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{paddingTop:10}} >
                              <TextField label='Mobile' onChange={event => setMobile(event.target.value)} value={mobile} placeholder={'Enter mobile'} fullWidth size='small' variant="outlined" onKeyPress={(event) => {numberOnly(event);}} inputProps={{ maxLength: 10 }} />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{paddingTop:10}} >
                              <TextField label='Phone' onChange={event => setPhone(event.target.value)} value={phone} placeholder={'Enter phone'} fullWidth size='small' variant="outlined" inputProps={{ maxLength: 20 }} />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{paddingTop:10}} >
                              <TextField label='Email' onChange={event => setEmail(event.target.value)} value={email} placeholder={'Enter email'} fullWidth size='small' variant="outlined" inputProps={{ maxLength: 60 }} />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td style={{paddingTop:10}} >
                              <TextField label='Website' onChange={event => setWebsite(event.target.value)} value={website} placeholder={'Enter website'} fullWidth size='small' variant="outlined" inputProps={{ maxLength: 125 }} />
                            </td>                            
                        </tr>

                      </table>
                      
                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          <Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
								      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>


    </>
  );

});

export default CustomizedDialogs;